export const TOKENS_STATUS = {
    success: 'success',
    error: 'failed',
    pending: 'processing'
};
export const THOUGHT_STATUS = {
    success: 'success',
    failed: 'failed',
    processing: 'processing',
    stop: 'stop'
};



// WEBPACK FOOTER //
// ./src/pages/chat-demo/components/static.js